var map = {
	"./roi_high-profile_community.jpg": "5829",
	"./roi_high-profile_infrastructure.jpg": "65dd",
	"./roi_high-profile_media.jpg": "c96b",
	"./roi_high-profile_procurement.jpg": "fe9a",
	"./roi_high-profile_taxes.jpg": "13d8",
	"./roi_high-profile_youth.jpg": "7850",
	"./tile_championLA.jpg": "6961",
	"./tile_hosting-the-world.jpg": "448c",
	"./tile_your-opportunity.jpg": "367a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6863";